import "@ncdai/react-wheel-picker/style.css";
import * as WheelPickerPrimitive from "@ncdai/react-wheel-picker";
import { cn } from "@/utils";
import { useEffect } from "react";

// Types
export type WheelPickerOption = WheelPickerPrimitive.WheelPickerOption;
export type WheelPickerClassNames = WheelPickerPrimitive.WheelPickerClassNames;

// Samsung WebView detection utility
function isSamsungWebView() {
  const ua = navigator.userAgent || "";
  const isSamsung = /SM-|SAMSUNG|SamsungBrowser/i.test(ua);
  const isWebView =
    /\bwv\b/.test(ua) || /Version\/\d+\.\d+ Chrome\/\d+/i.test(ua);
  return isSamsung && isWebView;
}

export function WheelPickerWrapper({
  className,
  ...props
}: React.ComponentProps<typeof WheelPickerPrimitive.WheelPickerWrapper>) {
  // Apply Samsung WebView fix on mount
  useEffect(() => {
    if (isSamsungWebView()) {
      document.body.classList.add("samwv");
    }
    // Cleanup on unmount
    return () => {
      if (isSamsungWebView()) {
        document.body.classList.remove("samwv");
      }
    };
  }, []);

  return (
    <WheelPickerPrimitive.WheelPickerWrapper
      className={cn(
        "w-[100%] rounded-lg bg-white shadow-xs dark:border-zinc-700/80 dark:bg-zinc-900",
        "*:data-rwp:first:*:data-rwp-highlight-wrapper:rounded-s-md",
        "*:data-rwp:last:*:data-rwp-highlight-wrapper:rounded-e-md",
        className
      )}
      {...props}
    />
  );
}

export function WheelPicker({
  classNames,
  ...props
}: React.ComponentProps<typeof WheelPickerPrimitive.WheelPicker>) {
  return (
    <WheelPickerPrimitive.WheelPicker
      classNames={{
        optionItem: "text-zinc-400 dark:text-zinc-500",
        highlightWrapper:
          "bg-zinc-100 text-zinc-950 dark:bg-zinc-800 text-[18px] dark:text-zinc-50",
        ...classNames,
      }}
      {...props}
    />
  );
}
